import { render, staticRenderFns } from "./EditVariant.vue?vue&type=template&id=2bf43ebb&scoped=true&"
import script from "./EditVariant.vue?vue&type=script&lang=js&"
export * from "./EditVariant.vue?vue&type=script&lang=js&"
import style0 from "./EditVariant.vue?vue&type=style&index=0&id=2bf43ebb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf43ebb",
  null
  
)

export default component.exports